import { useState, useEffect, useContext } from 'react';
import { useQuery } from '@apollo/client';
import { authContext } from 'contexts/AuthContext';
import { STAFF_LIST } from 'utils/CommonGraphQL';

export const useAssignedVendors = () => {
  const { auth } = useContext(authContext);
  const [assignedVendorIds, setAssignedVendorIds] = useState(null); // null means show all
  const [loading, setLoading] = useState(true);
  const [hasAssignedVendors, setHasAssignedVendors] = useState(false);

  const userId = auth?.data?.userId;
  const userRoles = auth?.data?.roles || [];

  const isSalesRole = userRoles.some(
    (role) =>
      role.name === 'SALES_EXECUTIVE' ||
      role.name === 'BDE' ||
      role.name === 'BUSINESS_DEVELOPMENT_EXECUTIVE' ||
      role.name === 'RM' ||
      role.name === 'RELATIONSHIP_MANAGER',
  );

  const {
    data,
    loading: queryLoading,
    error,
  } = useQuery(STAFF_LIST, {
    variables: {
      filter: [{ key: 'id', value: userId, type: 'INT', op: 'EQ' }],
    },
    skip: !userId || !isSalesRole,
    fetchPolicy: 'network-only',
  });

  useEffect(() => {
    if (!isSalesRole) {
      setAssignedVendorIds(null);
      setHasAssignedVendors(false);
      setLoading(false);
      return;
    }

    if (data?.usersFilter?.users?.[0]) {
      const user = data.usersFilter.users[0];

      const isBDE = user.roles?.some(
        (role) =>
          role.name === 'BDE' || role.name === 'BUSINESS_DEVELOPMENT_EXECUTIVE',
      );

      const vendors = isBDE
        ? user.bdeAssignedTraders || []
        : user.assignedTraders || [];

      if (vendors.length > 0) {
        // Extract vendor IDs and their phone numbers
        const vendorIds = vendors.map((vendor) => vendor.id);
        const vendorPhones = vendors.map((vendor) => vendor.phone);

        setAssignedVendorIds({ ids: vendorIds, phones: vendorPhones });
        setHasAssignedVendors(true);
      } else {
        // Sales role but no assigned vendors - show nothing
        setAssignedVendorIds({ ids: [], phones: [] });
        setHasAssignedVendors(false);
      }
      setLoading(false);
    } else if (!queryLoading) {
      setLoading(false);
    }
  }, [data, queryLoading, isSalesRole]);

  return {
    assignedVendorIds,
    loading,
    error,
    hasAssignedVendors,
    isSalesRole,
  };
};
